import { marcoNormativoData } from '@/mocks/nosotros-data';

export default function MarcoNormativoSection() {
  return (
    <section id="marco-normativo" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
              Biblioteca jurídica
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              {marcoNormativoData.title}
            </h2>
          </div>

          {/* Documents Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {marcoNormativoData.documentos.map((doc) => (
              <div
                key={doc.id}
                className="group rounded-2xl bg-background-100 border border-secondary-200/60 p-6 md:p-7 hover:border-primary-200/60 transition-all duration-300 flex flex-col"
              >
                {/* Icon */}
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-primary-50 text-primary-600 mb-4 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-file-text-line text-lg" />
                </span>

                {/* Content */}
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                  {doc.nombre}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed mb-5 flex-1">
                  {doc.descripcion}
                </p>

                {/* Actions */}
                <div className="flex items-center gap-3 pt-3 border-t border-secondary-200/60">
                  <button className="inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 text-xs font-semibold transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-eye-line text-sm" />
                    <span>Ver documento</span>
                  </button>
                  <button className="inline-flex items-center gap-1.5 text-foreground-500 hover:text-foreground-700 text-xs font-semibold transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-download-line text-sm" />
                    <span>Descargar PDF</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}